import { render, staticRenderFns } from "./CreatePostMessage.vue?vue&type=template&id=aba8c11e&"
import script from "./CreatePostMessage.vue?vue&type=script&lang=js&"
export * from "./CreatePostMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports